export default theme => ({
  cancelButton: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
});
